import React,{useState,useEffect} from "react";
import { faLongArrowLeft } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./ThankYou.css";
import thankyouimg from "../../../Images/thanks-you.png";

const longarrowaltleft = <FontAwesomeIcon icon={faLongArrowLeft} />

function thankyou() {
    
    return (
        <>
 

             
        <div className="thankyou_page">
            <section className="thankyou_section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="thankyou_text">
                            <img className="img-fluid" src={thankyouimg} alt="thankyouimg" />
                                <h2>We have received your information.</h2>
                                <p>Someone from our team will contact you shortly.</p>
                                <a href="https://moneysukh.com/" class="common_btn">
                                    <i>{longarrowaltleft}</i>		
                                    <span class="elementor-button-text">Back Home</span>
                                </a>
                            </div>
                        </div>
                      
                    </div>
                </div>
            </section>
            </div>

        </>
        
    )
    
}

export default thankyou;